module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAACMSURBVFhH7ZcxDoAwCEWpJ8ObcTQ8GUJbBocODgVjeIlSWXhp/2CbiEAmx6xpNCJK2wKdPQQQcbbiYOanAGLsRhBdXWBLBphbfwDO5dpJD+EWgXGkI1ertfOdEFojCp9nAvYS/RCrUfg8dZF/hvANJVACJVACJVACJZAu8I1/wtkLpwtoTb0eJ1/PAW782LsCUkzTOQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/walleris/images/EXEC_32.png
// module id = 58
// module chunks = 0